import { BASIC_COMPOSITION } from "@constants";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import React from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import {
    setIsInternalModification,
    setProductBeforeUpdate,
    setShowToast,
    steWorkflowStepIndex,
} from "@components/OrderTaking/Store/feature";

import { AddOrderBasicCompositionWorkflow } from "./hooks";
import { StepImage } from "./StepImage";

import "swiper/swiper-bundle.min.css";

export function WorkflowStepper({
    currentWorkflow,
    activestep,
    NextOnClickEvent,
    PreviousOnClickEvent,
}) {
    const swiperRef = React.useRef(null);
    const dispatch = useDispatch();
    const { isNextOrPreviousButtonsActive } = useSelector(
        (state) => state.settingSlice.compositeProductSettings,
        shallowEqual
    );
    const orderWorkflowItemSlice = useSelector(
        (state) => state.orderWorkflowItemSlice,
        shallowEqual
    );
    const { globalcard } = useSelector((state) => state.orderSlice);
    const { workflowData } = useSelector((state) => state.workFlowDataSlice);

    function handleStepperItemOnClickEvent(index) {
        if (index === activestep) return;

        if (
            index < activestep &&
            orderWorkflowItemSlice.isInternalModification === false &&
            orderWorkflowItemSlice.isModification === true
        ) {
            dispatch(
                setProductBeforeUpdate({ ...orderWorkflowItemSlice.item })
            );
        }
        let listworkflow = workflowData[workflowData.length - 1];
        if (
            index < activestep &&
            ((listworkflow?.workflow[activestep]?.NbrOfChoices >=
                listworkflow?.workflow[activestep]?.minNbrOfChoices &&
                orderWorkflowItemSlice.isModification === true) ||
                orderWorkflowItemSlice.isModification === false)
        ) {
            dispatch(setIsInternalModification(true));
            dispatch(steWorkflowStepIndex(index));
            return;
        }

        if (
            listworkflow?.workflow[activestep]?.NbrOfChoices <
            listworkflow?.workflow[activestep]?.minNbrOfChoices
        ) {
            const minNbrOfChoices =
                listworkflow?.workflow[listworkflow.index].minNbrOfChoices;
            const minProductToast = { minProduct: minNbrOfChoices };
            dispatch(setShowToast(minProductToast));
        }

        // ! check step required
        else if (
            listworkflow.workflow[activestep]?.NbrOfChoices >=
            listworkflow.workflow[activestep]?.minNbrOfChoices
        ) {
            if (index === activestep + 1) {
                dispatch(steWorkflowStepIndex(index));
            } else if (index > activestep + 1) {
                let data = [...listworkflow.workflow];
                data.length = index;

                const result = data.some(
                    (element) =>
                        element.minNbrOfChoices > 0 &&
                        element.NbrOfChoices < element.minNbrOfChoices
                );
                if (result === false) {
                    dispatch(steWorkflowStepIndex(index));
                }
            }
            // ! check step basic composition

            if (
                listworkflow.workflow[listworkflow.index].type ===
                BASIC_COMPOSITION
            ) {
                AddOrderBasicCompositionWorkflow(
                    workflowData,
                    dispatch,
                    globalcard
                );
            }
        }
    }

    const width =
        currentWorkflow?.length === 4
            ? "1025px"
            : currentWorkflow?.length > 4
            ? "920px"
            : "auto";

    document.documentElement.style.setProperty("--swiper-width", width);

    const [swiper, setSwiper] = React.useState(null);

    const haveHiddenBasicComp = React.useMemo(() => {
        return currentWorkflow?.some(
            (item) =>
                item.isHiddenBasicComp &&
                !orderWorkflowItemSlice.isModification &&
                !orderWorkflowItemSlice.isInternalModification
        );
    }, [
        currentWorkflow,
        orderWorkflowItemSlice.isModification,
        orderWorkflowItemSlice.isInternalModification,
    ]);

    const visibleSteps =
        orderWorkflowItemSlice.isModification ||
        orderWorkflowItemSlice.isInternalModification
            ? currentWorkflow
            : currentWorkflow?.filter(
                  (workflow) => !workflow.isHiddenBasicComp
              );
    const filteredActiveStepIndex = visibleSteps?.findIndex(
        (step) => step.uuidStep === currentWorkflow[activestep]?.uuidStep
    );

    // Ensure swiper slides to the correct visible step
    React.useEffect(() => {
        if (swiper && filteredActiveStepIndex >= 0) {
            swiper.slideTo(filteredActiveStepIndex);
        }
    }, [swiper, filteredActiveStepIndex]);
    return (
        <div
            className="d-flex justify-content-center align-items-center"
            style={{ width: "99%" }}
        >
            {isNextOrPreviousButtonsActive
                ? currentWorkflow?.length > 3 && (
                      <div
                          id="previousButton"
                          onClick={() => {
                              PreviousOnClickEvent();
                          }}
                          className="arrow-left top-button-position"
                      />
                  )
                : null}
            <Swiper
                onSwiper={setSwiper}
                slidesPerView={"auto"}
                slidesPerGroup={1}
                className={classNames("workflow-swiper-container", {
                    "workflow-swiper-container-items-fewer-than-four":
                        currentWorkflow?.length <= 4,
                })}
                ref={swiperRef}
                modules={[Navigation]}
                activestep={activestep}
            >
                {visibleSteps?.map((item, initialIndex) => {
                    const index = !haveHiddenBasicComp
                        ? initialIndex
                        : initialIndex + 1;
                    const cuurentIndex = !haveHiddenBasicComp
                        ? initialIndex
                        : initialIndex + 1;

                    const currentSwiperItem = {
                        ...item,
                        name: item.title,
                        isActive: cuurentIndex === activestep,
                        isCompleted:
                            (cuurentIndex === activestep &&
                                item.NbrOfChoices >= item.maxNbrOfChoices) ||
                            cuurentIndex < activestep,
                    };

                    return (
                        <SwiperSlide
                            key={currentSwiperItem.uuidStep}
                            className={classNames("workflow-swiper-slide")}
                            onClick={() => {
                                handleStepperItemOnClickEvent(index);
                            }}
                        >
                            <div className="d-flex flex-column justify-content-start align-items-center step-image">
                                <StepImage
                                    stepImageUrl={currentSwiperItem.image}
                                    isBasicComposition={
                                        currentSwiperItem.type ===
                                        BASIC_COMPOSITION
                                    }
                                />
                                <div
                                    className="d-flex align-items-center justify-content-center w-100 h-50"
                                    style={{ whiteSpace: "nowrap" }}
                                >
                                    <span
                                        className={
                                            workflowData.length > 1
                                                ? "workflow-step-title two-lines-preview-text"
                                                : "workflow-main-step-title two-lines-preview-text"
                                        }
                                    >
                                        {currentSwiperItem.title}
                                    </span>
                                </div>
                            </div>
                            {currentSwiperItem.isActive === true &&
                            currentSwiperItem.isCompleted === false ? (
                                <div className="d-flex align-items-center justify-content-center h-110">
                                    <div
                                        className={classNames({
                                            "active-line":
                                                index + 1 !==
                                                currentWorkflow?.length,
                                            none:
                                                index + 1 ===
                                                currentWorkflow?.length,
                                        })}
                                    />
                                    <div className="more-outer circle">
                                        <div className="d-flex flex-column justify-content-center align-items-center outer circle">
                                            <div className="d-flex flex-column justify-content-center  align-items-center step-item">
                                                <span>
                                                    {haveHiddenBasicComp
                                                        ? index
                                                        : index + 1}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : currentSwiperItem.isActive === true &&
                              currentSwiperItem.isCompleted === true ? (
                                <div className="d-flex align-items-center justify-content-center h-110">
                                    <div
                                        className={classNames({
                                            "completed-line":
                                                index + 1 !==
                                                currentWorkflow?.length,
                                            none:
                                                index + 1 ===
                                                currentWorkflow?.length,
                                        })}
                                    />
                                    <div className="more-outer circle">
                                        <div className="d-flex flex-column justify-content-center  align-items-center outer circle">
                                            <div className="d-flex flex-column justify-content-center  align-items-center step-item">
                                                <div className="inner-circle">
                                                    <span className="check" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : currentSwiperItem.isActive === false &&
                              currentSwiperItem.isCompleted === false ? (
                                <div className="d-flex align-items-center justify-content-center h-110">
                                    <div
                                        className={`step-item left-position non-active-step ${
                                            index === activestep + 1
                                                ? "tada-animation"
                                                : ""
                                        } step${index + 1}
                                    `}
                                    >
                                        <span>
                                            {haveHiddenBasicComp
                                                ? index
                                                : index + 1}
                                        </span>
                                    </div>
                                </div>
                            ) : currentSwiperItem.isActive === false &&
                              currentSwiperItem.isCompleted === true ? (
                                <div className="d-flex align-items-center  justify-content-center h-110">
                                    <div
                                        className={classNames({
                                            "completed-line":
                                                index + 1 !==
                                                currentWorkflow?.length,
                                            none:
                                                index + 1 ===
                                                currentWorkflow?.length,
                                        })}
                                    />
                                    <div className="step-item left-position">
                                        <div className="inner-circle">
                                            <span className="check" />
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </SwiperSlide>
                    );
                })}
            </Swiper>
            {isNextOrPreviousButtonsActive
                ? currentWorkflow?.length > 3 && (
                      <div
                          id="nextButton"
                          onClick={() => {
                              NextOnClickEvent();
                          }}
                          className="arrow-right top-button-position"
                      />
                  )
                : null}
        </div>
    );
}

WorkflowStepper.propTypes = {
    currentWorkflow: PropTypes.array,
    activestep: PropTypes.number,
    NextOnClickEvent: PropTypes.func,
    PreviousOnClickEvent: PropTypes.func,
};
